module.exports = __webpack_public_path__ + "static/media/Github.20883410.svg";